export default "__VITE_ASSET__EEr2wo7u__"